import disclaimerModalWarning from "../../resources/js/module/disclaimer-modal";
import mapController from "../../resources/js/module/mapController";
import MapFilter from "../../resources/js/module/mapFilter";

document.addEventListener('DOMContentLoaded', () => {
    const disclaimerModal = document.querySelector('.tr-disclaimer-modal');
    const map = document.querySelector('#interactive-map > svg');

    if (disclaimerModal) {
        disclaimerModalWarning(disclaimerModal);
    }

    if (map) {
        const controller = mapController(map, {
            disableInteractions: false,
        });
        const mapFilter = new MapFilter(controller);
        mapFilter.init();
    }
});
